<template>
	<div class="text-container">
		<div class="title">ix cam隐私政策</div>
		<div>
			我们的隐私政策已于2026年9月22日更新，将会于2026年9月22日生效。我们对隐私政策进行了详细修订，从该日期开始，这一隐私政策能够提供有关我们如何管理您在使用所有ix cam产品和服务时透露的个人信息的隐私详情，特定的ix cam产品或服务提供独立的隐私政策除外。
		</div>
		<div>
			请花一些时间熟悉我们的隐私权惯例，如果您有任何问题，请告诉我们。
		</div>
		<div class="title">我们向您承诺</div>
		<div>
			本隐私政策规定了广州钱柜物联科技有限公司及关联公司（下文简称"ix cam"或"我们"）如何收集、使用、披露、处理和保护您在使用我们的产品和服务时通过ix cam  APP提供给我们的信息。若我们要求您提供某些信息，以便在使用ix cam产品和服务时验证您的身份，我们将严格遵守本隐私政策和/或我们的用户条款与条件来使用这些信息。
		</div>
		<div>
			本隐私政策在制定时充分考虑到您的需求；您全面了解我们的个人资料收集和使用惯例，而且确信自己最终能控制提供给ix cam的所有个人信息，这一点至关重要。
		</div>
		<div>
			在这项隐私政策中，"个人信息"指所有通过有关特定个人的信息，或者与ix cam能够访问的其他关于该人的信息相结合后，能够直接或间接识别该人的所有数据。此类个人信息包括但不限于您提供或上传的信息和设备信息
		</div>
		<div>
			通过使用ix cam产品和服务或其他符合使用法律的操作，即表示您已阅读并接受本隐私政策中所述之所有条款，包括我们定期作出的任何变更。为遵守使用法律，包括本地数据保护法律（如欧盟的《全面数据保护法规》），我们将会对于特定类别的个人数据的处理（如自动个体决策）征求您的明确同意。另外，我们承诺遵照适用法律（包括您所在地的数据保护法律）来保护您的个人信息的隐私、机密和安全。同时我们承诺确保我们的全体员工和代理商履行这些义务。
		</div>
		<div>
			最后，我们所希望的就是为我们的用户带来最好的体验。如果您对这一隐私政策中概括的数据处理惯例有任何疑问，请通过FAE@naxclow.com联系我们，以便我们处理您的需求，我们很高兴直接为您答疑解惑。
		</div>
		<div class="title">一、哪些信息会被收集以及我们如何使用这些信息？</div>
		<div class="subtitle">（一）您须授权我们收集和使用您个人信息的情形</div>
		<div>
			收集个人信息的目的在于向您提供产品和/或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。您有权自行选择是否提供该信息，但多数情况下，如果您不提供，我们可能无法向您提供相应的服务，也无法回应您遇到的问题。这些功能包括：
		</div>
		<div class="numtitle">（1） 智能连接</div>
		<div>
			为了给您提供ix cam的服务，使您可以安全地连接、管理智能设备，我们可能会收集您的Wi-Fi信息、IP地址、位置信息、登录帐号信息、手机相关信息，智能设备相关信息，以及ix cam账号和智能设备的关联信息。这些信息将用于为您提供智能设备快连、连接、发现附近设备和设备管理的功能。上述各项信息，详细列举如下：
		</div>
		<div>• 登录帐号信息：ix cam账号、昵称、头像信息。</div>
		<div>
			• 手机相关信息：硬件设备标识(imsi、imei、meid、设备硬件序列号、SIM卡标识、OAID、Mac地址、AndroidID)、手机型号、系统版本信息、系统语言、手机所设置的国家或地区、应用商店的版本号、手机屏幕尺寸及分辨率、CPU及显示设备相关信息。
		</div>
		<div>
			• 连接智能设备过程中收集的信息：基于您需要链接的智能设备的类型，我们可能会收集如下信息：
		</div>
		<div>
			• 通过Wi-Fi连接的智能设备：Wi-Fi信息（SSID,BSSID,Wi-Fi的Mac地址、Wi-Fi密码）、设备Mac地址、设备ID。
		</div>
		<div>
			• 通过蓝牙建立本地连接后，通过Wi-Fi连接的智能设备：Wi-Fi信息（SSID,BSSID,Wi-Fi的Mac地址、Wi-Fi密码）、设备Mac地址、设备蓝牙Mac地址。
		</div>
		<div>• 通过蓝牙连接的智能设备：设备蓝牙Mac地址、设备ID。</div>
		<div>• 开启消息推送后：应用程序前后台获取设备识别码：包含IMEI、IDFA、Android ID、MAC、OAID、Advertising ID、Google Advertising ID（GAID）、SerialNumber、IMSI、UAID、ICCID、您安装的应用信息或运行中的 进程信息。</div>
		<div class="numtitle">（2） 设备共享</div>
		<div>
			我们支持您将智能设备通过ix cam账号、手机号和微信，分享他人一起使用。经分享后，被分享者同样可以对智能设备进行控制。为了享受此功能，我们可能收集您的帐号ID、您提供的分享帐号ID、被分享的设备信息（设备ID、设备名称、设备验证key、设备的分享状态），用于为您提供将设备分享给其他ix cam账号的用户共同控制、使用的功能，以及用于设备列表页展示分享状态
		</div>
		<div class="numtitle">（3） 应用和智能硬件升级：</div>
		<div>
			收集个人信息的目的在于向您提供产品和/为了使您持续享受最新的ix cam服务，我们可能会使用您ix cam应用的版本信息、手机型号用于为您提供ix cam应用的升级服务。同时，我们可能收集您已连接的智能设备列表和版本号信息，用于为您提供智能设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。
		</div>
		<div class="subtitle">
			（二）您可选择是否授权我们收集和使用您的个人信息的情形
		</div>
		<div>
			为使您更好的享受ix cam为您提供的智能设备的控制、管理等，我们的以下附加功能中可能会收集和使用您的个人信息。如果您不提供这些个人信息，您依然可以使用ix cam的基础服务，但您可能无法使用这些可以为您所带来便利的附加功能。这些附加功能包括：
		</div>
		<div class="numtitle">（1）移动侦测识别管理</div>
		<div>
			如果您通过ix cam平台连接了支持移动侦测识别功能的特定产品（如A9），您可以开启ix cam支持的移动侦测识别功能以获得更丰富的智能设备体验。当我们识别到有人移动时，我们会在智能设备中为您标记和推送消息。
		</div>
		<div>
			如果您对我们识别的结果有疑问，您可以和我们反馈以帮助我们优化算法和模型。在此情况下，我们可能会收集您主动反馈的问题视频。请您放心，您反馈的视频仅会用于优化算法和模型，不会用于其他用途。
		</div>
		<div class="numtitle">（2） 智能设备共享</div>
		<div>
			我们支持您将智能设备通过ix cam账号和微信，分享他人一起使用。经分享后，被分享者同样可以对智能设备进行控制。为了享受此功能，我们可能收集您的帐号 ID、您提供的分享帐号 ID、被分享的设备信息（设备ID、设备名称、设备验证 key、设备的分享状态），用于为您提供将设备分享给其他ix cam账号的用户共同控制、使用的功能，以及用于设备列表页展示分享状态。
		</div>
		<div class="numtitle">（3） 版本升级</div>
		<div>
			为了使您持续享受最新的 ix cam服务，我们可能会使用您 ix camAPP的版本信息、手机型号用于为您提供ix cam的升级服务。同时，我们可能收集您已连接的智能设备列表和版本号信息，用于为您提供智能设备的升级功能，以确保您可以使用最新版本的服务（包括固件版本）。
		</div>
		<div class="numtitle">（4） 用户反馈</div>
		<div>
			我们可能收集您发给我们的反馈的问题、反馈日志，以及您填写的电话号码或邮箱，这些信息将用于让我们更好的了解您遇到的问题，以及联系您。
		</div>
		<div class="subtitle">（三）ix cam权限调用说明</div>
		<div>
			此外，在您使用ix cam时可能会触发以下设备权限。为使您更好地管理您的信息，我们会在产品使用过程权限申请时同步告知您该权限的使用目的，以及如您不开启该权限可能对您使用服务的影响，请您仔细查阅。您在使用特定功能前，可选择是否授权开通以下权限。同时，您可以随时通过设备权限设置页面自己更改授权情况。
		</div>
		<div>以下为相关功能及调用权限的细节，为您列举供参考：</div>
		<div style="font-weight: bold;">
			1.读写外部存储空间（Android版本）：用于在扫一扫、用户反馈等功能中读写设备上的照片及文件。
		</div>
		<div style="font-weight: bold;">
			2.位置权限（Android、iOS版本）：用于扫描附近WLAN列表、搜索附近蓝牙设备以及智能场景中自动化地理围栏等功能；当用户绑定了不支持gps的设备时，用于提供步频计算、运动准确距离的记录、画出用户的运动轨迹等功能。
		</div>
		<div style="font-weight: bold;">
			3.相机权限（Android、iOS版本）：用于扫描二维码以进行设备安装、账号登录等功能。
		</div>
		<div style="font-weight: bold;">
			4.麦克风权限（Android、iOS版本）：当用户在ix cam中绑定了摄像机、可视门铃、等设备时，用于视频对讲、语音指令的拾音等功能
		</div>
		<div style="font-weight: bold;">
			5.读取电话权限（Android）：用于在客户端本地生成设备id。
		</div>
		<div style="font-weight: bold;">
			6.开启WLAN权限（Android、iOS版本）：用于快连设备时，连接设备发出的WIFI，以进行设备通信。
		</div>
		<div style="font-weight: bold;">
			7.开启蓝牙权限（Android、iOS版本）：用于在快连设备时，连接设备发出的蓝牙信号，以进行设备通信；对于通过蓝牙连接的智能设备，也需要蓝牙权限用于通信。
		</div>
		<div style="font-weight: bold;">
			8.获取手机软件安装列表（Android、iOS版本）：用于获取手机的第三方账户用于便快捷登录。
		</div>
		<div style="font-weight: bold;">
			9.获取硬件设备标识(imsi、imei、meid、设备硬件序列号、SIM 卡标识、移动安全联盟 OAID、Mac地址、Android ID)、手机型号、系统版本信息：用户消息推送获取警报
		</div>
		<div style="font-weight: bold;">
		  10.获取手机传感器信息（陀螺仪传感器,重力传感器,加速度传感器）：用于广告投放、广告归因、反作弊、安全
		</div>
		<div style="font-weight: bold;">
		  11.相册权限（Android、iOS 版本）：用于在扫一扫、用户反馈等功能中读写设备上的照片及视频；
		</div>
		<div style="font-weight: bold;">
		  12.剪切板（Android、iOS版本）：剪切板功能用于分享功能实现。
		</div>
		<div style="font-weight: bold;">
		  13.获取设备信息(IMSI、IDFV)设备品牌、运营商信息、网络信息、应用信息(应用名、应用版本号)：用于一键登录功能。
		</div>
		<div class="subtitle">
			（四）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的同意：
		</div>
		<div>
			我们可能会使用您的姓名、电话号码、电子邮箱地址、ix cam及ix cam账号、IMEI号码向您提供广州钱柜物联科技有限公司及其合作伙伴（提供网络、移动应用程序和云产品和服务）的产品和服务相关的推广资料。我们严格遵守您所在地的数据保护法（一些法律可能会要求独立的明确许可），所以我们只会在征得您事先明确的同意，并且会通过一项清晰的肯定操作，确认我们已征得您的同意或您表示不反对之后，才会使用您的个人信息。如果您不希望再收到某些类别的电子邮件，您可以点击位于页面下方的链接退订邮件。我们不会将您的个人信息传送给我们的商业伙伴用于直接市场推广。
		</div>
		<div class="subtitle">我们与谁共享您的信息？</div>
		<div>1.与国家安全、国防安全有关的；</div>
		<div>2.与公共安全、公共卫生、重大公共利益有关的；</div>
		<div>3.与犯罪侦查、起诉、审判和判决执行等有关的；</div>
		<div>
			4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
		</div>
		<div>
			5.所收集的个人信息是个人信息主体自行向社会公众公开的；
		</div>
		<div>
			6.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
		</div>
		<div>7.根据您的要求签订合同所必需的；</div>
		<div>
			8.用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
		</div>
		<div>9.为合法的新闻报道所必需的；</div>
		<div>
			10.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
		</div>
		<div>
			您的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证您的个人信息具有最高的安全等级。我们保证通过访问这些信息来帮助向您提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。
		</div>
		<div class="subtitle">（五）我们从第三方获得您个人信息的情形</div>
		<div>
			在一些法律允许的情况下，我们可能从第三方处获得您的个人信息。
		</div>
		<div class="subtitle">（六）非个人信息</div>
		<div>
			我们还可能收集其他无法识别到特定个人的信息（即不属于个人信息的信息），例如您使用特定服务时产生的统计类数据，如用户的操作行为（包括点击、页面跳转、浏览时间）。收集此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品和/或服务。
			我们会将此类信息汇总，用于帮助我们向客户提供更有用的信息，了解客户对我们网站、产品和服务中的哪些部分最感兴趣。就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
		</div>
		<div class="numtitle">二、保留政策</div>
		<div>
			我们基于本隐私政策中所述的信息收集的目的所必需的期间，或者遵守适用的相关法律要求保留个人信息。个人信息在完成收集目的，或在我们确认您的删除或注销申请后，或我们终止运营相应产品或服务后，我们将停止保留，并做删除或匿名化处理。如果是出于公众利益、科学、历史研究或统计的目的，我们将基于适用的法律继续保留相关数据，即使进一步的数据处理与原有的收集目的无关。
		</div>
		<div>
			• 根据《中华人民共和国电子商务法》，您的商品和服务信息、交易信息保存时间自交易完成之日起不得少于三年。
		</div>
		<div class="subtitle">三、您的权利</div>
		<div class="numtitle">（一）控制设置</div>
		<div>
			我们承认每个人对隐私权的关注各不相同。因此，我们提供了一些示例，说明ix cam提供的各种方式，供您选择，以限制收集、使用、披露或处理您的个人信息，并控制您的隐私权设置：
			打开或者关闭位置访问、相机、录音和读写手机存储权限；
		</div>
		<div class="subtitle">
			• 在ix camAPP中点击“我的-设置-个人资料”修改您的个人信息，包括昵称、头像等；
		</div>
		<div>• 登入或登出ix cam账户</div>
		<div>
			如果您之前因为上述目的同意我们使用您的个人信息，您可以随时通过书面或者通过访问 FAE@naxclow.com联系我们来改变您的决定
		</div>
		<div class="numtitle">（二）您对您的个人信息享有的权利</div>
		<div>
			根据您所适用的国家或地区法律法规，您有权要求访问、更正、删除我们持有的与您相关的任何个人信息（以下简称请求）。
		</div>
		<div>
			与您ix cam账号中的个人信息相关的更多详细信息，您可以通过FAE@naxclow.com或者通过您的设备登入帐号来访问和更改。其他信息，请致信或者通过访问FAE@naxclow.com 联系我们。
			大多数法律要求个人信息主体提出的请求应遵循特定要求，本隐私政策要求您的请求应当符合以下情形：
		</div>
		<div>
			• 通过我们专门的请求渠道，并且出于保护您的信息安全的考虑，您的请求应当是书面的（除非当地法律明确承认口头申请）；：
		</div>
		<div>
			• 提供足够的信息使我们可以验证您的身份，确保请求人是所请求信息主体本人或合法授权人
		</div>
		<div>
			• 一旦我们获得充分信息确认可处理您的请求时，我们将在适用数据保护法律规定的时间内对您的请求做出回应。具体而言：
		</div>
		<div>
			• 基于您的要求及适用法律规定，我们可免费提供一份我们已收集并处理的关于您的个人信息记录，如您提出对于相关信息的其他请求，我们可能会基于相关适用法律，并结合实际的管理成本向您收取一笔合理的费用。
		</div>
		<div>
			• 如果您认为我们持有的关于您的任何信息是不正确或不完整的，可要求基于使用目的更正或完善个人信息。
		</div>
		<div>
			• 根据您适用的法律法规，您可能有权要求我们删除您的个人数据。我们将会根据您的删除请求进行评估，若满足相应规定，我们将会采取包括技术手段在内的相应步骤进行处理。当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。例如，根据《中华人民共和国电子商务法》，您的商品和服务信息、交易信息保存时间自交易完成之日起不得少于三年。
		</div>
		<div>
			• 我们有权拒绝处理无实质意义/纠缠式重复的请求、损害他人隐私权的请求、极端不现实的请求，要求不相称的技术工作，以及根据当地法律无需给予的请求，已经公之于众的信息，保密条件下给出的信息。如果我们认为删除数据或访问数据的请求的某些方面可能会导致我们无法出于前述反欺诈和安全目的合法使用数据，可能也会予以拒绝
		</div>
		<div class="numtitle">（三）撤销同意</div>
		<div>
			• 您可以通过提交请求撤销同意，包括收集、使用和/或披露我们掌握或控制的您的个人信息。根据您所使用的具体服务，您可以在应用内通过“我的”-“用户协议和隐私政策”来实现，或者可以通过访问FAE@naxclow.com联系我们进行相关操作。我们将会在您做出请求后的十五天内处理您的请求，并且会根据您的请求，在此后不再收集、使用和/或披露您的个人信息。
		</div>
		<div>
			• 请注意，您撤销同意会导致某些法律后果。根据您授权我们处理信息的范围，这可能导致您不能享受ix cam的产品或服务。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
		</div>
		<div class="numtitle">（四）注销服务或账号</div>
		<div>
			如您希望注销具体产品或服务，您可以通过访问FAE@naxclow.com联系我们进行服务注销。如您希望注销ix cam账号，由于注销ix cam账号的操作将使您无法使用ix cam全线产品和服务，请您谨慎操作。我们为了保护您或他人的合法权益会结合您对ix cam各产品和服务的使用情况判断是否支持您的注销请求。
		</div>
		<div>
			PS：你可以通过“ix cam”APP中的“我的”-“账号安全”-注销账号来发起注销账号的申请，
		</div>
		<div class="subtitle">四、与第三方服务提供商共享您的个人信息</div>
		<div>
			本业务中部分服务内容由第三方服务提供商提供，为此我们需要向第三方服务提供商提供您的部分个人信息，我们向关联方、合作伙伴及第三方共享您的个人信息的情形。如我们与这些第三方分享您的个人信息，我们将采取加密等手段保障您的信息安全。对我们与之共享个人信息的公司、组织，我们会对其数据安全环境进行合理审查，并与其签署严格的数据处理协议，要求第三方对您的信息采取足够的保护措施，严格遵守相关法律法规与监管要求。
		</div>
		<div>
			为ix camApp相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关SDK在目录中列明，详情请点击<a target="_blank" type="text/vue" style="font-weight: bold;" href="#/sdk/sdk_file">《附件—第三方SDK说明》</a>。请注意，第三方SDK及关联方可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。
		</div>
		<div class="subtitle">五、政策的更新</div>
		<div>
		  本政策将根据业务模式的调整或更新不定期进行修订，该等修订构成本隐私政策的一部分。
		</div>
		<div>
		  未经您的明确同意，我们不会削减您按照本政策所享有的权利。如果变更的本政策条款会削减您的权利或增加您的义务（即发生“重大变更”），我们将在ix cam官方网站公示，并且以合适的方式（包括通过弹窗提示、电子邮件、短信等）及时告知，以说明本政策的更新情况，并会在变更生效前给您和开发者预留合理的期限供您考虑是否接受变更。
		</div>
		<div>
		  若用户不同意更新后的本政策，可以停止使用ix cam的服务以及应用，若用户在更新后的本政策生效后继续使用ix cam的服务以及应用，即表示用户已经充分阅读并同意更新后的本政策。
		</div>
		<div class="subtitle">六、联系我们</div>
		<div>
			如果您对本隐私政策有任何意见或问题，或者您对我们收集、使用或披露您的个人信息有任何问题，请通过下方地址或通过访问FAE@naxclow.com联系我们，并提及“隐私政策”。针对您关于个人信息相关的权利请求、问题咨询等时，我们有专业的团队解决你的问题。如果你的问题本身涉及比较重大的事项，我们可能会要求你提供更多信息。如果您对收到的答复不满意，您可以将投诉移交给所在司法辖区的相关监管机构。如果您咨询我们，我们会根据您的实际情况，提供可能适用的相关投诉途径的信息。
		</div>
		<div>
			如果您对本隐私政策有任何意见或问题，或者您对ix cam收集、使用或披露您的个人信息有任何问题，请通过下列地址联系我们的数据保护官，并提及"隐私政策 "：
		</div>
		<div>
			广州钱柜物联有限公司
		</div>
		<div>
			广州市南沙区珠电路四号华汇国际916-918房： FAE@naxclow.com
		</div>
		<div>感谢您花时间了解我们的隐私政策！</div>
	</div>
</template>

<script type="text/javascript">
	import { mapState } from "vuex"
	export default {
		data() {
			return {};
		},
		created() {
			console.log(this.$router);
		},
		methods: {},
		computed: {
			...mapState({
				tableData: "tableData"
			})
		}
	};
</script>

<style lang="less" scoped>
	.text-container {
		padding: 0 20px 50px;
		word-break:break-all;
		.title {
			font-size: 30px;
			margin: 15px 0;
			font-weight: 900;
		}

		.subtitle {
			font-size: 25px;
			margin: 10px 0;
			font-weight: 600;
		}

		.numtitle {
			font-size: 20px;
			margin: 10px 0;
			font-weight: 600;
		}
		.SDKTitle{
			  font-size: 20px;
			  margin: 15px 0;
			  text-align: center;
		}
	}
</style>
